var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import cn from 'classnames';
import deprecated from 'react-prop-types/lib/deprecated';
import themeColors from '../utils/themeColors';
import getCollapserStyles from '../utils/getCollapserStyles';
import getField from '../utils/getField';
import controlled from '../utils/PropTypes/controlled';
import { TAB } from '../constants/keyCodes';
import anchorShape from '../Helpers/anchorShape';
import fixedToShape from '../Helpers/fixedToShape';
import AccessibleFakeInkedButton from '../Helpers/AccessibleFakeInkedButton';
import Collapse from '../Helpers/Collapse';
import Divider from '../Dividers/Divider';
import FontIcon from '../FontIcons/FontIcon';
import getDeprecatedIcon from '../FontIcons/getDeprecatedIcon';
import TileAddon from './TileAddon';
import ListItemText from './ListItemText';
import List from './List';
import Menu from '../Menus/Menu';

/**
 * The `ListItem` component is used for rendering a `li` tag with text and optional
 * icons/avatars.
 */

var ListItem = function (_PureComponent) {
  _inherits(ListItem, _PureComponent);
  function ListItem(props) {
    _classCallCheck(this, ListItem);
    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
    _initialiseProps.call(_this);
    _this.state = {
      active: false
    };
    if (typeof props.isOpen === 'undefined' && typeof props.visible === 'undefined') {
      var defined = function defined(v) {
        return typeof v !== 'undefined';
      };
      var _this$props = _this.props,
        initiallyOpen = _this$props.initiallyOpen,
        defaultOpen = _this$props.defaultOpen,
        defaultVisible = _this$props.defaultVisible;
      var visible = defined(initiallyOpen) ? initiallyOpen : defaultVisible;
      visible = defined(defaultOpen) ? defaultOpen : visible;
      visible = !!visible;
      _this.state.visible = visible;
    }
    return _this;
  }
  ListItem.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.state.active) {
      window.removeEventListener('click', this._handleOutsideClick);
    }
    if (this._touchTimeout) {
      clearTimeout(this._touchTimeout);
    }
  };

  /**
   * A utility function to focus the `AccessibleFakeInkedButton` in the `ListItem` and also
   * inject an ink to indicate focus.
   */

  /**
   * A utility function to blur the `AccessibleFakeInkedButton` in the `ListItem`.
   */

  ListItem.prototype._renderChildrenIfInside = function _renderChildrenIfInside() {
    var _props = this.props,
      children = _props.children,
      renderChildrenOutside = _props.renderChildrenOutside;
    return !renderChildrenOutside ? children : null;
  };
  ListItem.prototype._renderChildrenIfOutside = function _renderChildrenIfOutside() {
    var _props2 = this.props,
      children = _props2.children,
      renderChildrenOutside = _props2.renderChildrenOutside;
    if (renderChildrenOutside) {
      return React.createElement('div', {
        className: 'md-list-item--flex'
      }, React.createElement(Divider, {
        vertical: true,
        className: 'md-list-item--divider-vertical'
      }), React.createElement('div', {
        className: 'md-list-item--children-inline'
      }, children));
    }
    return null;
  };
  ListItem.prototype.render = function render() {
    var _cn;
    var _props3 = this.props,
      style = _props3.style,
      className = _props3.className,
      tileStyle = _props3.tileStyle,
      tileClassName = _props3.tileClassName,
      contentStyle = _props3.contentStyle,
      contentClassName = _props3.contentClassName,
      leftNodeStyle = _props3.leftNodeStyle,
      leftNodeClassName = _props3.leftNodeClassName,
      rightNodeStyle = _props3.rightNodeStyle,
      rightNodeClassName = _props3.rightNodeClassName,
      primaryTextStyle = _props3.primaryTextStyle,
      primaryTextClassName = _props3.primaryTextClassName,
      secondaryTextStyle = _props3.secondaryTextStyle,
      secondaryTextClassName = _props3.secondaryTextClassName,
      nestedListStyle = _props3.nestedListStyle,
      nestedListClassName = _props3.nestedListClassName,
      nestedListHeightRestricted = _props3.nestedListHeightRestricted,
      disabled = _props3.disabled,
      leftIcon = _props3.leftIcon,
      leftAvatar = _props3.leftAvatar,
      inset = _props3.inset,
      rightIcon = _props3.rightIcon,
      rightAvatar = _props3.rightAvatar,
      primaryText = _props3.primaryText,
      secondaryText = _props3.secondaryText,
      threeLines = _props3.threeLines,
      nestedItems = _props3.nestedItems,
      prependNested = _props3.prependNested,
      active = _props3.active,
      activeClassName = _props3.activeClassName,
      activeBoxStyle = _props3.activeBoxStyle,
      activeBoxClassName = _props3.activeBoxClassName,
      animateNestedItems = _props3.animateNestedItems,
      expanderIcon = _props3.expanderIcon,
      expanderLeft = _props3.expanderLeft,
      component = _props3.component,
      ItemComponent = _props3.itemComponent,
      itemProps = _props3.itemProps,
      tileProps = _props3.tileProps,
      passPropsToItem = _props3.passPropsToItem,
      ariaSize = _props3['aria-setsize'],
      ariaPos = _props3['aria-posinset'],
      renderChildrenOutside = _props3.renderChildrenOutside,
      isOpen = _props3.isOpen,
      expanderIconChildren = _props3.expanderIconChildren,
      expanderIconClassName = _props3.expanderIconClassName,
      propVisible = _props3.visible,
      defaultVisible = _props3.defaultVisible,
      itemRef = _props3.itemRef,
      defaultOpen = _props3.defaultOpen,
      initiallyOpen = _props3.initiallyOpen,
      props = _objectWithoutProperties(_props3, ['style', 'className', 'tileStyle', 'tileClassName', 'contentStyle', 'contentClassName', 'leftNodeStyle', 'leftNodeClassName', 'rightNodeStyle', 'rightNodeClassName', 'primaryTextStyle', 'primaryTextClassName', 'secondaryTextStyle', 'secondaryTextClassName', 'nestedListStyle', 'nestedListClassName', 'nestedListHeightRestricted', 'disabled', 'leftIcon', 'leftAvatar', 'inset', 'rightIcon', 'rightAvatar', 'primaryText', 'secondaryText', 'threeLines', 'nestedItems', 'prependNested', 'active', 'activeClassName', 'activeBoxStyle', 'activeBoxClassName', 'animateNestedItems', 'expanderIcon', 'expanderLeft', 'component', 'itemComponent', 'itemProps', 'tileProps', 'passPropsToItem', 'aria-setsize', 'aria-posinset', 'renderChildrenOutside', 'isOpen', 'expanderIconChildren', 'expanderIconClassName', 'visible', 'defaultVisible', 'itemRef', 'defaultOpen', 'initiallyOpen']);
    var _context = this.context,
      cascadingId = _context.cascadingId,
      cascadingMenu = _context.cascadingMenu,
      cascadingAnchor = _context.cascadingAnchor,
      cascadingFixedTo = _context.cascadingFixedTo;
    var visible = getField(this.props, this.state, 'visible');
    if (typeof isOpen !== 'undefined') {
      visible = isOpen;
    }
    var leftNode = React.createElement(TileAddon, {
      key: 'left-addon',
      style: leftNodeStyle,
      className: leftNodeClassName,
      active: active,
      activeClassName: activeClassName,
      icon: leftIcon,
      avatar: leftAvatar
    });
    var rightNode = React.createElement(TileAddon, {
      key: 'right-addon',
      style: rightNodeStyle,
      className: rightNodeClassName,
      active: active,
      activeClassName: activeClassName,
      icon: rightIcon,
      avatar: rightAvatar
    });
    var nestedList = void 0;
    if (nestedItems) {
      if (!cascadingMenu) {
        nestedList = React.createElement(Collapse, {
          collapsed: !visible,
          animate: animateNestedItems
        }, React.createElement(List, {
          style: nestedListStyle,
          className: nestedListClassName
        }, nestedItems));
      }
      var icon = React.Children.only(getDeprecatedIcon(expanderIconClassName, expanderIconChildren, expanderIcon));
      var collapser = React.createElement(TileAddon, {
        key: 'expander-addon',
        icon: React.cloneElement(icon, {
          className: getCollapserStyles({
            flipped: visible
          }, icon.props.className)
        }),
        avatar: null
      });
      if (expanderLeft) {
        if (!leftIcon && !leftAvatar) {
          leftNode = collapser;
        }
      } else if (!rightIcon && !rightAvatar) {
        rightNode = collapser;
      }
    }
    var icond = !!leftIcon || !!rightIcon || !!nestedItems;
    var avatard = !!leftAvatar || !!rightAvatar;
    var tile = React.createElement(AccessibleFakeInkedButton, _extends({}, tileProps, passPropsToItem ? undefined : props, {
      component: component,
      __SUPER_SECRET_REF__: this._setTile,
      key: 'tile',
      onClick: this._handleClick,
      onMouseOver: this._handleMouseOver,
      onMouseLeave: this._handleMouseLeave,
      onTouchStart: this._handleTouchStart,
      onTouchEnd: this._handleTouchEnd,
      onKeyDown: this._handleKeyDown,
      onKeyUp: this._handleKeyUp,
      disabled: disabled,
      style: tileStyle,
      className: cn('md-list-tile', {
        'md-list-tile--active': this.state.active && !this._touched,
        'md-list-tile--icon': !secondaryText && icond && !avatard,
        'md-list-tile--avatar': !secondaryText && avatard,
        'md-list-tile--two-lines': secondaryText && !threeLines,
        'md-list-tile--three-lines': secondaryText && threeLines,
        'md-list-item--inset': inset && !leftIcon && !leftAvatar,
        'md-list-item--button-grow': renderChildrenOutside
      }, themeColors({
        disabled: disabled,
        text: true
      }), tileClassName),
      'aria-expanded': nestedList && !cascadingMenu ? visible : null
    }), leftNode, React.createElement(ListItemText, {
      active: active,
      activeClassName: activeClassName,
      disabled: disabled,
      primaryText: primaryText,
      secondaryText: secondaryText,
      threeLines: threeLines,
      style: contentStyle,
      className: cn({
        'md-tile-content--left-icon': leftIcon || expanderLeft && nestedItems,
        'md-tile-content--left-avatar': leftAvatar,
        'md-tile-content--right-padding': rightIcon || rightAvatar
      }, contentClassName),
      primaryTextStyle: primaryTextStyle,
      primaryTextClassName: primaryTextClassName,
      secondaryTextStyle: secondaryTextStyle,
      secondaryTextClassName: secondaryTextClassName
    }), rightNode, this._renderChildrenIfInside());
    var sharedProps = _extends({}, itemProps, passPropsToItem ? props : undefined, {
      style: Object.assign({}, style, active ? activeBoxStyle : null),
      className: cn('md-list-item', (_cn = {
        'md-list-item--nested-container': nestedItems
      }, _cn[activeBoxClassName] = activeBoxClassName && active, _cn['md-list-item--flex'] = renderChildrenOutside, _cn), className),
      'aria-setsize': ariaSize,
      'aria-posinset': ariaPos,
      ref: this._setContainer
    });
    if (cascadingMenu && nestedItems) {
      return React.createElement(Menu, _extends({
        id: cascadingId,
        visible: visible,
        onClose: this._handleClick,
        toggle: tile,
        block: true,
        simplified: false,
        anchor: cascadingAnchor,
        belowAnchor: null,
        position: Menu.Positions.BELOW,
        component: ItemComponent,
        listStyle: nestedListStyle,
        listClassName: nestedListClassName,
        listHeightRestricted: nestedListHeightRestricted
      }, sharedProps, {
        fixedTo: cascadingFixedTo
      }), nestedItems);
    }
    return React.createElement(ItemComponent, sharedProps, prependNested ? nestedList : null, tile, this._renderChildrenIfOutside(), prependNested ? null : nestedList);
  };
  return ListItem;
}(PureComponent);
ListItem.propTypes = {
  /**
   * An optional style to apply to the `li` tag.
   */
  style: PropTypes.object,
  /**
   * An optional className to apply to the `li` tag.
   */
  className: PropTypes.string,
  /**
   * An optional style to apply to the `.md-list-tile`.
   *
   * @see {@link #component}
   */
  tileStyle: PropTypes.object,
  /**
   * An optional className to apply to the `.md-list-tile`.
   *
   * @see {@link #component}
   */
  tileClassName: PropTypes.string,
  /**
   * An optional style to apply to the div that surrounds the `primaryText` and `secondaryText`
   * nodes.
   */
  contentStyle: PropTypes.object,
  /**
   * An optional className to apply to the div that surrounds the `primaryText` and `secondaryText`
   * nodes.
   */
  contentClassName: PropTypes.string,
  /**
   * An optional style to apply to the element that is rendered before content node.
   */
  leftNodeStyle: PropTypes.object,
  /**
   * An optional className to apply to the element that is rendered before content node.
   */
  leftNodeClassName: PropTypes.string,
  /**
   * An optional style to apply to the element that is rendered after content node.
   */
  rightNodeStyle: PropTypes.object,
  /**
   * An optional className to apply to the element that is rendered after content node.
   */
  rightNodeClassName: PropTypes.string,
  /**
   * An optional style to apply to the div surrounding the `primaryText`.
   */
  primaryTextStyle: PropTypes.object,
  /**
   * An optional className to apply to the div surrounding the `primaryText`.
   */
  primaryTextClassName: PropTypes.string,
  /**
   * An optional style to apply to the div surrounding the `secondaryText`.
   */
  secondaryTextStyle: PropTypes.object,
  /**
   * An optional className to apply to the div surrounding the `secondaryText`.
   */
  secondaryTextClassName: PropTypes.string,
  /**
   * An optional style to apply to the nested `List` that gets created when using `nestedItems`.
   */
  nestedListStyle: PropTypes.object,
  /**
   * An optional className to apply to the nested `List` that gets created when using `nestedItems`.
   */
  nestedListClassName: PropTypes.string,
  /**
   * Boolean if the nested `List` in a cascading menu should be restricted.
   */
  nestedListHeightRestricted: PropTypes.bool,
  /**
   * Any additional children to display in the `.md-list-tile`. If you use this prop,
   * you will most likely need to override the `height` for the `.md-list-tile--icon`,
   * `.md-list-tile--avatar`, `.md-list-tile--two-lines`, and/or `.md-list-tile--three-lines`
   * to get it to display correctly unless the children are positioned `absolute`.
   */
  children: PropTypes.node,
  /**
   * Boolean if the `ListItem` is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * An optional tab index for the `.md-list-tile`. If omitted, it will default to the
   * `AccessibleFakeButton`'s `tabIndex` default prop value.
   */
  tabIndex: PropTypes.number,
  /**
   * The primary text to display. This will only be rendered as a single line. Any overflown
   * text will be converted to ellipsis.
   */
  primaryText: PropTypes.node.isRequired,
  /**
   * An optional secondary text to display below the `primaryText`. This can be an additional
   * one or two lines. Like the `primaryText`, and overflown text will be converted to ellipsis.
   *
   * You must set the `threeLines` prop to `true` if you want this to be displayed as two lines.
   */
  secondaryText: PropTypes.node,
  /**
   * An optional `FontIcon` to display to the left of the text.
   */
  leftIcon: PropTypes.node,
  /**
   * An optional `Avatar` to display to the left of the text. If you have a mixed `List` of
   * `FontIcon` and `Avatar`, it is recommended to set the `iconSized` prop on the `Avatar` to
   * `true` so that the `Avatar` will be scaled down to the `FontIcon` size.
   */
  leftAvatar: PropTypes.node,
  /**
   * An optional `FontIcon` to display to the right of the text.
   */
  rightIcon: PropTypes.node,
  /**
   * An optional `Avatar` to display to the right of the text. If you have a mixed `List` of
   * `FontIcon` and `Avatar`, it is recommended to set the `iconSized` prop on the `Avatar` to
   * `true` so that the `Avatar` will be scaled down to the `FontIcon` size.
   */
  rightAvatar: PropTypes.node,
  /**
   * Boolean if the list item should be inset as if there is a `leftIcon` or a `leftAvatar`.
   * This is used for some lists where only a parent contains the icon.
   */
  inset: PropTypes.bool,
  /**
   * Boolean if the `secondaryText` should span two lines instead of one. This will include
   * three lines of text in total when including the `primaryText`.
   */
  threeLines: PropTypes.bool,
  /**
   * The component to render the `.md-list-tile` as. This is mostly useful if you
   * want to use the `ListItem` for navigation and working with the `react-router`'s `Link`
   * component.
   *
   * This prop is **not** the top-most element of the `ListItem` component. To change the
   * top-most element, see the `itemComponent` prop.
   *
   * @see {@link #itemComponent}
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]).isRequired,
  /**
   * The component to render the top-most element of the `ListItem` component. This is the
   * `.md-list-item` and defaults to the `<li>` element.
   *
   * @see {@link #component}
   * @see {@link #itemProps}
   */
  itemComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]).isRequired,
  /**
   * An optional ref callback to get reference to the top-most element of the `ListItem` component.
   * Just like other refs, this will provide null when it unmounts.
   */
  itemRef: PropTypes.func,
  /**
   * An optional list of `ListItem`, `ListItemControl`, `Divider`, or `Subheader` components
   * to render in a nested list. This will inject an expander icon to the right of the text
   * in the `.md-list-tile` that rotates 180 degrees when open.
   *
   * The nested items will be visible once the user clicks on the `ListItem`.
   *
   * @see {@link #visible}
   */
  nestedItems: PropTypes.arrayOf(PropTypes.node),
  /**
   * An optional parameter determining whether `nestedItems` should be placed before or after `ListItemText`
   */
  prependNested: PropTypes.bool,
  /**
   * Boolean if the `nestedItems` are visible by default.
   */
  defaultVisible: PropTypes.bool,
  /**
   * Boolean if the `nestedItems` are visible. This will make the `nestedItems` controlled
   * and require the `onClick` function to be defined.
   *
   * @see {@link #defaultVisible}
   */
  visible: controlled(PropTypes.bool, 'onClick', 'defaultVisible'),
  /**
   * An icon to use for the expander icon when there are nested items.
   */
  expanderIcon: PropTypes.element,
  /**
   * Boolean if the expander icon should appear as the left icon instead of the right.
   */
  expanderLeft: PropTypes.bool,
  /**
   * An optional function to call when the `.md-list-tile` is clicked. This is required if the
   * `visible` prop is defined.
   */
  onClick: PropTypes.func,
  /**
   * An optional function to call when the `.md-list-tile` triggers the `mouseover` event.
   */
  onMouseOver: PropTypes.func,
  /**
   * An optional function to call when the `.md-list-tile` triggers the `mouseleave` event.
   */
  onMouseLeave: PropTypes.func,
  /**
   * An optional function to call when the `.md-list-tile` triggers the `touchstart` event.
   */
  onTouchStart: PropTypes.func,
  /**
   * An optional function to call when the `.md-list-tile` triggers the `touchend` event.
   */
  onTouchEnd: PropTypes.func,
  /**
   * An optional function to call when the `.md-list-tile` triggers the `keydown` event.
   */
  onKeyDown: PropTypes.func,
  /**
   * An optional function to call when the `.md-list-tile` triggers the `keyup` event.
   */
  onKeyUp: PropTypes.func,
  /**
   * Boolean if the `ListItem` is currently active. This will apply the `activeClassName` prop
   * to the `leftIcon`, `rightIcon`, and the `primaryText`.
   */
  active: PropTypes.bool,
  /**
   * The className to apply to the `leftIcon`, `rightIcon`, and `primaryText` when the `active`
   * prop is `true`.
   */
  activeClassName: PropTypes.string,
  /**
   * An optional style to apply to the top-most element of the `ListItem` component (`.md-list-item`)
   * when the `active` prop is `true`.
   */
  activeBoxStyle: PropTypes.object,
  /**
   * The className to apply to the top-most element of the `ListItem` component (`.md-list-item`)
   * when the `active` prop is `true`.
   */
  activeBoxClassName: PropTypes.string,
  /**
   * Boolean if the nested items should animate when they appear or disappear.
   */
  animateNestedItems: PropTypes.bool,
  /**
   * Boolean if the children should be rendered outside auf the AccessibleFakeButton component.
   */
  renderChildrenOutside: PropTypes.bool,
  /**
   * Defines the number of items in the list. This is only required when all items in the
   * list are not present in the DOM.
   *
   * @see https://www.w3.org/TR/wai-aria/states_and_properties#aria-setsize
   */
  'aria-setsize': PropTypes.number,
  /**
   * Defines the items position in the list. This is only required when all items in the list
   * are not present in the DOM. The custom validation just requires this prop if the `aria-setsize`
   * prop is defined as a helpful reminder.
   *
   * @see https://www.w3.org/TR/wai-aria/states_and_properties#aria-posinset
   */
  'aria-posinset': function ariaPosinset(props, propName) {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    var validator = PropTypes.number;
    if (typeof props['aria-setsize'] !== 'undefined') {
      validator = validator.isRequired;
    }
    return validator.apply(undefined, [props, propName].concat(args));
  },
  /**
   * Any additional props you would like to supply to the surrounding `<li>` tag for the `ListItem`.
   * By default, all props will be provided to the inner `AccessibleFakeButton`. If the `passPropsToItem`
   * prop is enabled, the remaining props will be provided to the `<li>` tag instead and this prop
   * is probably useless.
   */
  itemProps: PropTypes.object,
  /**
   * Any additional props you would like to add to the inner `AccessibleFakeButton`. By default, all the
   * remaining props will be provided to the `AccessibleFakeButton`, so this prop is probably useless.
   * Enabling the `passPropsToItem` prop will change the default behavior so that the remaining props
   * are provided to the surrounding `<li>` node instead and this prop becomes useful.
   */
  tileProps: PropTypes.object,
  /**
   * All the remaining props should be passed to the surrounding `<li>` node instead of the `AccessibleFakeButton`.
   *
   * > NOTE: This will most likely become the default in the next *major* release. Migration warnings will be added
   * if that is the case.
   */
  passPropsToItem: PropTypes.bool,
  expanderIconChildren: deprecated(PropTypes.node, 'Use `expanderIcon` instead'),
  expanderIconClassName: deprecated(PropTypes.string, 'Use `expanderIcon` instead'),
  initiallyOpen: deprecated(PropTypes.bool, 'Use `defaultVisible` instead'),
  defaultOpen: deprecated(PropTypes.bool, 'Use `defaultVisible` instead'),
  isOpen: deprecated(PropTypes.bool, 'Use `visible` instead')
};
ListItem.defaultProps = {
  animateNestedItems: true,
  activeClassName: 'md-text--theme-primary',
  component: 'div',
  itemComponent: 'li',
  expanderIcon: React.createElement(FontIcon, null, 'keyboard_arrow_down'),
  renderChildrenOutside: false
};
ListItem.contextTypes = {
  cascadingId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  cascadingMenu: PropTypes.bool,
  cascadingAnchor: anchorShape,
  cascadingFixedTo: fixedToShape
};
var _initialiseProps = function _initialiseProps() {
  var _this2 = this;
  this.focus = function () {
    if (_this2._tile) {
      _this2._tile.focus();
    }
  };
  this.blur = function () {
    if (_this2._tile) {
      _this2._tile.blur();
    }
  };
  this._setTile = function (tile) {
    if (tile) {
      _this2._tile = tile;
      _this2._tileNode = findDOMNode(tile);
    }
  };
  this._setContainer = function (container) {
    var itemRef = _this2.props.itemRef;
    if (container) {
      _this2._container = findDOMNode(container);
    }
    if (itemRef) {
      itemRef(container ? _this2._container : null);
    }
  };
  this._handleOutsideClick = function (e) {
    if (_this2._container && !_this2._container.contains(e.target)) {
      window.removeEventListener('click', _this2._handleOutsideClick);
      _this2.setState({
        active: false
      });
    }
  };
  this._handleClick = function (e) {
    if (_this2.props.onClick) {
      _this2.props.onClick(e);
    }
    if (typeof _this2.state.visible !== 'undefined') {
      _this2.setState({
        visible: !_this2.state.visible
      });
    }
  };
  this._handleMouseOver = function (e) {
    if (_this2.props.onMouseOver) {
      _this2.props.onMouseOver(e);
    }
    if (!_this2.props.disabled) {
      _this2.setState({
        active: true
      });
    }
  };
  this._handleMouseLeave = function (e) {
    if (_this2.props.onMouseLeave) {
      _this2.props.onMouseLeave(e);
    }
    if (!_this2.props.disabled) {
      _this2.setState({
        active: false
      });
    }
  };
  this._handleTouchStart = function (e) {
    if (_this2.props.onTouchStart) {
      _this2.props.onTouchStart(e);
    }
    _this2._touched = true;
    _this2.setState({
      active: true,
      touchedAt: Date.now()
    });
  };
  this._handleTouchEnd = function (e) {
    if (_this2.props.onTouchEnd) {
      _this2.props.onTouchEnd(e);
    }
    var time = Date.now() - _this2.state.touchedAt;
    _this2._touchTimeout = setTimeout(function () {
      _this2._touchTimeout = null;
      _this2.setState({
        active: false
      });
    }, time > 450 ? 0 : 450 - time);
  };
  this._handleKeyUp = function (e) {
    if (_this2.props.onKeyUp) {
      _this2.props.onKeyUp(e);
    }
    if ((e.which || e.keyCode) === TAB) {
      window.addEventListener('click', _this2._handleOutsideClick);
      _this2.setState({
        active: true
      });
    }
  };
  this._handleKeyDown = function (e) {
    if (_this2.props.onKeyDown) {
      _this2.props.onKeyDown(e);
    }
    if ((e.which || e.keyCode) === TAB) {
      window.removeEventListener('click', _this2._handleOutsideClick);
      _this2.setState({
        active: false
      });
    }
  };
};
export default ListItem;